import { render, staticRenderFns } from "./EntityDataEditInvestmentModeFields.vue?vue&type=template&id=dafb3072&scoped=true"
import script from "./EntityDataEditInvestmentModeFields.vue?vue&type=script&lang=js"
export * from "./EntityDataEditInvestmentModeFields.vue?vue&type=script&lang=js"
import style0 from "./EntityDataEditInvestmentModeFields.vue?vue&type=style&index=0&id=dafb3072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafb3072",
  null
  
)

export default component.exports